// Задержка перед переходом, чтобы успела отправиться аналитика клика
export const NAVIGATION_DELAY = 300;

/**
 * Переходит на страницу мобильного сайта.
 * Мобильную навигацию карта показывает по ширине экрана, поэтому кукой flavour явно просим cian.ru
 * отдать мобильную версию страницы, даже если по user-agent он открыл бы десктопную (например, на планшете)
 */
export function openMobileSitePage(href: string) {
  setTimeout(() => {
    document.cookie = 'flavour=mobile;domain=.cian.ru;path=/';
    window.location.href = href;
  }, NAVIGATION_DELAY);
}
